import request from "../Tools/request/request";

// 列表
export function getList(data) {
    return request({
        url: "/user/auth/list",
        method: "post",
        data,
    });
}

// 审核
export function getReview(data) {
    return request({
        url: "/user/user-auth/review",
        method: "post",
        data,
    });
}

// 查看详情
export function getDetail(data) {
    return request({
        url: "/user/url/list",
        method: "post",
        data,
    });
}